import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { motion,  } from 'framer-motion';
import { 
  FiHeart, 
  FiShare2, 

  FiZap,

} from 'react-icons/fi'; 

import './ProfilCar.css';

import { Link, useParams } from 'react-router-dom';
import API_CONFIG2 from '../API_CONFIG2/API_CONFIG2';
import ReservationForm from './ReservationForm';
import ReservationFormNONdispo from './ReservationFormNONdispo';

const FormulaireReserve = () => {
  const { id, statut } = useParams();
  const [car, setCar] = useState(null);

  const [isLiked, setIsLiked] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);


  // AJOUT: Définition des animations
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        duration: 0.8
      }
    }
  };

  const cardVariants = {
    hidden: { 
      opacity: 0, 
      y: 30,
      scale: 0.95
    },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        type: "spring",
        stiffness: 100,
        damping: 15
      }
    }
  };



  const fetchCar = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await axios.get(`${API_CONFIG2.apiUrl}Get_VehiculeByStatut.php?id=${id}&statut=${statut}`, { 
        timeout: 10000 
      });

      if (response.data.success) {
        setCar(response.data.vehicle);
      } else {
        setError(response.data.message || 'Véhicule introuvable');
      }
    } catch (err) {
      console.error('Erreur API:', err);
      setError(err.response?.data?.message || 'Impossible de charger les données du véhicule');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) fetchCar();
  }, [id, statut]);

  if (loading) {
    return (
      <div className="loading-container">
        <motion.div 
          className="loading-spinner"
          animate={{ 
            rotate: 360,
            scale: [1, 1.1, 1]
          }}
          transition={{ 
            rotate: { duration: 1, repeat: Infinity, ease: "linear" },
            scale: { duration: 1.5, repeat: Infinity }
          }}
        />
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2, repeat: Infinity, repeatType: "reverse", duration: 1 }}
        >
          Chargement du véhicule...
        </motion.p>
      </div>
    );
  }

  if (error) {
    return (
      <motion.div 
        className="error-container"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ type: "spring", stiffness: 200 }}
      >
        <div className="error-icon">⚡</div>
        <h3>Erreur de chargement</h3>
        <p>{error}</p>
        <motion.button 
          className="retry-button"
          onClick={fetchCar}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          Réessayer
        </motion.button>
      </motion.div>
    );
  }

  if (!car) return null;



  return (
    <motion.div 
      className="profil-car-container"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      {/* En-tête élégant */}
      <motion.div 
        className="car-header"
        variants={cardVariants}
        whileHover={{ y: -2 }}
      >
        <div className="header-content">
          <div className="title-section">
            <motion.div 
              className="car-badge text-left"
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.3, type: "spring" }}
            >
              <FiZap className="badge-icon" />
              {car.statut}
            </motion.div>
            
            <h1 className="car-title text-left">
               
              <Link to='/RentCars'><span className="brand">Retour au parc automobile </span></Link> 
              <span className="brand">{car.marque}</span>
              <span className="model">{car.modele}</span>
            </h1>
            
          </div>
          
          <div className="price-section">
            <div className="price-main">
              <motion.span 
                className="price"
                initial={{ scale: 0.8 }}
                animate={{ scale: 1 }}
                transition={{ delay: 0.4, type: "spring" }}
              >
                {car.prix?.toLocaleString()} $
              </motion.span>
              <span className="price-label">Prix TTC</span>
            </div>
            <div className="action-buttons">
              <motion.button 
                className={`like-button ${isLiked ? 'liked' : ''}`}
                onClick={() => setIsLiked(!isLiked)}
                whileHover={{ 
                  scale: 1.1,
                  rotate: isLiked ? 0 : 10 
                }}
                whileTap={{ scale: 0.9 }}
                animate={{
                  scale: isLiked ? [1, 1.2, 1] : 1
                }}
                transition={{ duration: 0.3 }}
              >
                <FiHeart />
              </motion.button>
              <motion.button 
                className="share-button"
                whileHover={{ scale: 1.1, rotate: -5 }}
                whileTap={{ scale: 0.9 }}
              >
                <FiShare2 />
              </motion.button>
            </div>
          </div>
        </div>
      </motion.div>
      {statut === 'Disponible'&&(
        <ReservationForm id = {id} statut = {car.statut} prix = {car.prix}  />
      )}
       {statut === 'Non Disponible'&&(
        <ReservationFormNONdispo id = {id} statut = {car.statut} prix = {car.prix} date_fin={car.date_fin}  />
      )}
     

    </motion.div>
  );
};

export default FormulaireReserve;